// Controller for auto-closing elements after a delay
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 3000 } // Default 3 seconds
  }

  connect() {
    if (this.delayValue > 0) {
      this.timeout = setTimeout(() => {
        this.close()
      }, this.delayValue)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  close() {
    // Dispatch event to close the modal
    window.dispatchEvent(
      new CustomEvent("auto-close:closeModal")
    )
  }
}
